import type {
  PassengerSeatSelectionInstance,
  PassengerSelectedSeat
} from "@app/types/seat-selection-types";

import type { Direction } from "./seat-selector";

export const createPassenger = (
  options: Partial<PassengerSeatSelectionInstance> = {}
): PassengerSeatSelectionInstance => {
  const {
    passenger_category,
    outbound_selected_seat,
    return_selected_seat,
    questions,
    selected_seats
  } = options;

  return {
    passenger_category: passenger_category || "adult",
    outbound_selected_seat: outbound_selected_seat || null,
    return_selected_seat: return_selected_seat || null,
    questions: questions || {},
    selected_seats: selected_seats || []
  };
};

const setSegmentSeat = (
  selected_seats: PassengerSelectedSeat[],
  seat_id: string | null | undefined,
  segment_id: string
) => {
  const seats = [...selected_seats];
  const seat_index = seats.findIndex(seat => seat.segment_id === segment_id);

  const has_seat_id = typeof seat_id === "string";

  const should_replace_seat = seat_index > -1 && has_seat_id;
  const should_add_seat = seat_index === -1 && has_seat_id;
  const should_remove_seat = seat_index > -1 && !has_seat_id;

  if (should_replace_seat) {
    seats[seat_index] = { segment_id, seat_id };
  }

  if (should_add_seat) {
    seats.push({
      segment_id,
      seat_id
    });
  }

  if (should_remove_seat) {
    seats.splice(seat_index, 1);
  }

  return seats;
};

export const setPassengerSeat = (
  passenger: PassengerSeatSelectionInstance,
  seat_id: string,
  segment_id: string,
  direction: Direction
): PassengerSeatSelectionInstance => {
  const {
    passenger_category,
    outbound_selected_seat,
    return_selected_seat,
    selected_seats
  } = passenger;

  const options = {
    passenger_category,
    outbound_selected_seat,
    return_selected_seat,
    selected_seats
  };

  const option_direction =
    direction === "outbound"
      ? "outbound_selected_seat"
      : "return_selected_seat";

  options[option_direction] = seat_id;

  if (segment_id && options.selected_seats) {
    options.selected_seats = setSegmentSeat(
      options.selected_seats,
      seat_id,
      segment_id
    );
  }

  return createPassenger(options);
};
